// Счётчики разделов почты для значка в шапке и вкладок «Почта · Атаки · Друзья · Новости»:
// перечитываются по событиям сокета, после прочтения, при возврате во вкладку браузера и раз в минуту.
import { onSocket } from '@/api/socket';
import { useApi, useLiveReload } from '@/lib/hooks';
import { ALLIANCE_CHAT_READ, MAIL_COUNTS_CHANGED, NEWS_READ } from '@/lib/mailEvents';
import { useGame } from '@/store/game';
import { useEffect } from 'react';

interface Unread {
  userId: string;
  /** Непрочитанные письма и сообщения в чатах альянса и групп. */
  count: number;
  news?: number;
  friends?: number;
}

const RELOAD_ON = new Set(['mail', 'news', 'friend_request', 'friend_accepted']);

export function useMailCounts() {
  const userId = useGame((s) => s.user?.id);
  const attacks = useGame((s) => s.incoming.length);
  const unread = useApi<Unread>(userId ? '/messages/unread' : null, [userId]);
  useLiveReload(unread.reload);
  useEffect(() => {
    const reload = () => {
      if (!document.hidden) void unread.reload();
    };
    const events = ['focus', ALLIANCE_CHAT_READ, NEWS_READ, MAIL_COUNTS_CHANGED];
    for (const e of events) window.addEventListener(e, reload);
    const timer = window.setInterval(reload, 60_000);
    // Новое сообщение в чате альянса и в своих чатах тоже считается в почте
    const offChat = onSocket('chat:message', (m) => {
      if ((m.channel === 'alliance' || m.channel === 'group') && m.from.id !== userId) reload();
    });
    const offNote = onSocket('notification', (n) => {
      if (RELOAD_ON.has(n.type)) reload();
    });
    return () => {
      for (const e of events) window.removeEventListener(e, reload);
      window.clearInterval(timer);
      offChat();
      offNote();
    };
  }, [unread.reload, userId]);
  const d = userId && unread.data?.userId === userId ? unread.data : null;
  const mail = d?.count ?? 0;
  const news = d?.news ?? 0;
  const friends = d?.friends ?? 0;
  return { mail, news, friends, attacks, total: mail + news + friends };
}
